export default __webpack_public_path__ + "static/media/sh-logo-icon.d8ed1ad0.svg";